<footer
	class="fixed bottom-0 left-0 right-0 w-full bg-surface-container text-on-surface z-[1000]"
	[ngClass]="themeService.isDarkMode() ? 'dark' : ''"
>
	<ng-content select="[footer-tabs]"></ng-content>

	@if (!isAdminPage && visiblitiesService.controlVisibilities().showRaceControlControl) {
		<vb-lxp-race-control-marquee></vb-lxp-race-control-marquee>
	}

	<div class="pr-4 py-3 items-stretch border-t-2 border-secondary relative overflow-hidden">
		@if (imagePaths && imagePaths.length > -1) {
			<div class="footer-logos-row flex justify-center items-center gap-24 overflow-x-auto">
				<div class="footer-text">
					Official <br />
					Partners
				</div>

				@for (imagePath of imagePaths; track imagePath) {
					<a [href]="imagePath.link">
						<img
							[src]="imagePath.src"
							[alt]="'Footer image'"
							class="h-[26px] w-auto object-contain"
						/>
					</a>
				}
			</div>
		}
	</div>
</footer>
